import React from 'react';
import { CalendarIcon } from '@heroicons/react/24/outline';

interface AddToCalendarButtonProps {
  sessionId: string;
  className?: string;
  iconOnly?: boolean;
}

/**
 * AddToCalendarButton redirects to the session-calendar edge function URL
 * which returns an ICS file that opens directly in the user's calendar app.
 */
export const AddToCalendarButton: React.FC<AddToCalendarButtonProps> = ({
  sessionId,
  className,
  iconOnly = false,
}) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent triggering parent click handlers

    const env = (window as any).__ENV__;
    const baseUrl = env?.SUPABASE_URL;

    if (!baseUrl) {
      console.error('Missing SUPABASE_URL');
      return;
    }

    // Build URL with session_id and caller=guide - no auth required
    const icsUrl = `${baseUrl}/functions/v1/session-calendar?session_id=${encodeURIComponent(sessionId)}&caller=guide`;

    // Redirect to open the ICS file directly
    window.location.href = icsUrl;
  };

  if (iconOnly) {
    return (
      <button
        type="button"
        onClick={handleClick}
        className={
          className ||
          'p-1 rounded hover:bg-[#F3EBCD] transition-colors text-[#2C2731]/70 hover:text-[#2C2731]'
        }
        aria-label="Add to calendar"
        title="Add to calendar"
      >
        <CalendarIcon className="h-4 w-4" />
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      className={
        className ||
        'inline-flex items-center gap-1.5 rounded-md border border-[#2C2731] bg-[#FFFCEF] px-2.5 py-1.5 text-xs font-medium text-[#2C2731] transition-colors hover:bg-[#F3EBCD]'
      }
      aria-label="Add to calendar"
    >
      <CalendarIcon className="h-3.5 w-3.5" />
      Add to Calendar
    </button>
  );
};

export default AddToCalendarButton;
